
import { defineComponent } from "vue";

export default defineComponent({
  props: {
    imageURL: {
      type: String,
      required: true
    }
  }
});
